'use strict';

import GenericTableData from './GenericTableData';

let ServiceContractData = GenericTableData.getTableDataBus(
  'SERVICE_CONTRACT',
  'service_contracts',
);

ServiceContractData.getServiceContractList = (opts) => {
  let where = {
    ...(opts?.where && { ...opts.where }),
  };
  let options = {
    ...opts,
    where: where,
    _include:
      '$service_contract_details.organizations,$service_contract_details.resources,vendors,users',
  };
  return ServiceContractData.getRecordList(options);
};

ServiceContractData.getServiceContractsForOrg = (orgId) => {
  return ServiceContractData.getRecordList(
    {
      where: {
        '*$service_contract_details.organization_id': orgId,
      },
      _include: '$service_contract_details.resource,vendors,users',
      _sort: 'name',
      _pageSize: 1000,
    },
    false,
    'SC_LIST_FOR_CORE_LOADED',
  );
};

ServiceContractData.getServiceContractAndAssociations = (id) => {
  return ServiceContractData.getRecord(id, {
    _include:
      '$transactions.documents,$transactions.charge_allocations,vendors,users,documents,' +
      '$service_contract_details.documents,$service_contract_details.resources,' +
      '$service_contract_details.organizations,service_contract_notes',
  });
};

let exportCols = [
  { key: 'id', header: 'ID' },
  { key: 'vendor', header: 'Vendor' },
  { key: 'name', header: 'Description' },
  {
    key: 'service_contract_details',
    header: 'Assets',
    fieldKey: 'resource.name',
  },
  {
    key: 'service_contract_details',
    header: 'Core Facility',
    fieldKey: 'organization.name',
  },
  // { key: 'user', header: 'User' },
  { key: 'description', header: 'Notes' },
  { key: 'start_date', header: 'Start Date' },
  { key: 'end_date', header: 'End Date' },
  {
    key: 'details',
    header: 'Total Amount',
    fieldKey: 'total_amount',
  },
  {
    key: 'details',
    header: 'Payment Arrangements',
    fieldKey: 'payment_arrangements',
  },
  {
    key: 'details',
    header: 'Date Paid',
    fieldKey: 'date_paid',
  },
  {
    key: 'details',
    header: 'Amount Owed',
    fieldKey: 'amount_owed',
  },
  {
    key: 'details',
    header: 'Up for Renewal',
    fieldKey: 'up_for_renewal',
  },
  {
    key: 'transactions',
    header: 'Transactions',
    fields: ['id', 'purchase_total', 'has_cleared'],
  },
];

ServiceContractData.exportContractList = (opts) => {
  ServiceContractData.exportRecordList({
    ...opts,
    _include:
      '$service_contract_details.organizations,$service_contract_details.resources,vendors,users,$transactions.documents,$transactions.charge_allocations',
    columns: exportCols,
  });
};
export default ServiceContractData;
